/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const ConversationIncludeOption = {
    Participants: 'PARTICIPANTS',
    ConversationType: 'CONVERSATION_TYPE',
    ListItemTemplateData: 'LIST_ITEM_TEMPLATE_DATA',
    ClientHeaderTemplateData: 'CLIENT_HEADER_TEMPLATE_DATA',
    ConversationData: 'CONVERSATION_DATA',
    CurrentUserReadStatus: 'CURRENT_USER_READ_STATUS',
    ClientParticipantFrontendUrl: 'CLIENT_PARTICIPANT_FRONTEND_URL',
    ParticipantNotificationStatus: 'PARTICIPANT_NOTIFICATION_STATUS'
} as const;
export type ConversationIncludeOption = typeof ConversationIncludeOption[keyof typeof ConversationIncludeOption];


export function instanceOfConversationIncludeOption(value: any): boolean {
    for (const key in ConversationIncludeOption) {
        if (Object.prototype.hasOwnProperty.call(ConversationIncludeOption, key)) {
            if (ConversationIncludeOption[key as keyof typeof ConversationIncludeOption] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ConversationIncludeOptionFromJSON(json: any): ConversationIncludeOption {
    return ConversationIncludeOptionFromJSONTyped(json, false);
}

export function ConversationIncludeOptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConversationIncludeOption {
    return json as ConversationIncludeOption;
}

export function ConversationIncludeOptionToJSON(value?: ConversationIncludeOption | null): any {
    return value as any;
}

export function ConversationIncludeOptionToJSONTyped(value: any, ignoreDiscriminator: boolean): ConversationIncludeOption {
    return value as ConversationIncludeOption;
}

